import ClearIcon from '@mui/icons-material/Clear'
import SaveIcon from '@mui/icons-material/Save'
import { Box, Button } from '@mui/material'
import { useDispatch } from 'react-redux'
import { closeModal } from '../../../store/reducers/modal/modal.slice'

interface ConfirmBlackListModalProps {
  onConfirm: () => void
  onConfirmWithoutBlacklist?: () => void
  onCancel?: () => void
  blackList: string[]
}

const ConfirmBlackListModal = ({
  onConfirm,
  onCancel,
  blackList,
  onConfirmWithoutBlacklist,
}: ConfirmBlackListModalProps) => {
  const dispatch = useDispatch()

  return (
    <Box sx={{ p: 3 }}>
      <ul>
        {blackList.map((item, index) => {
          return <li>{item}</li>
        })}
      </ul>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          mt: 2,
        }}
      >
        <Button
          startIcon={<ClearIcon />}
          color="inherit"
          onClick={() => {
            if (onCancel) {
              onCancel()
            }
            dispatch(closeModal())
          }}
          size="large"
          variant="contained"
        >
          ยกเลิก
        </Button>
        <Button
          startIcon={<SaveIcon />}
          color="primary"
          onClick={onConfirm}
          size="large"
          variant="contained"
        >
          ยืนยันทั้งหมด
        </Button>
        <Button
          startIcon={<SaveIcon />}
          color="info"
          onClick={onConfirmWithoutBlacklist}
          size="large"
          variant="contained"
        >
          ยืนยันยกเว้นรายชื่อ Blacklist
        </Button>
      </Box>
    </Box>
  )
}

export default ConfirmBlackListModal
